import { Link } from 'react-router-dom';
import Footer from '../Layouts/Footer';
import Canonical from '../../seo/Canonical';
import RelatedLinks from '../Common/RelatedLinks';
import { CASE_STUDIES_RELATED_BLOGS } from '../../data/resourcePageRelatedBlogs';
import './CaseStudiesPage.css';

/**
 * Lightweight “success stories” hub — links to reviews, services, contact and blog guides.
 * Linked from the homepage brand video section for internal SEO.
 */
export default function CaseStudiesPage() {
  return (
    <div className="case-studies-page">
      <Canonical baseUrl="https://www.pickpackpro.co.uk" />

      <section className="case-studies-hero">
        <h1>UK Fulfilment Success Stories</h1>
        <p>
          Every successful eCommerce business has a unique journey, and behind every growing brand is a fulfilment
          partner that keeps operations running smoothly. At Pick Pack Pro, we understand that no two businesses are the
          same. Whether you&apos;re an Amazon seller managing thousands of FBA shipments, a Shopify store experiencing
          rapid growth, or a TikTok Shop brand fulfilling hundreds of daily orders, your fulfilment requirements are
          unique. That&apos;s why we provide flexible, scalable, and reliable UK fulfilment services tailored to modern
          online retailers — the same multi-channel model we cover in{' '}
          <Link to="/blog/amazon-shopify-ebay-tiktok-one-3pl-uk">
            Amazon, Shopify, eBay &amp; TikTok: can one 3PL handle all channels?
          </Link>
          .
        </p>
        <p>
          Our fulfilment centre supports businesses of all sizes, from start-ups launching their first products to
          established brands processing thousands of orders each month. We work closely with every client to improve
          efficiency, reduce costs, and deliver an outstanding customer experience — whether you need{' '}
          <Link to="/blog/shopify-fulfilment-company-uk">Shopify fulfilment</Link>,{' '}
          <Link to="/blog/tiktok-shop-fulfilment-uk">TikTok Shop fulfilment UK</Link>,{' '}
          <Link to="/blog/amazon-fba-prep-guide-uk-sellers">Amazon FBA prep</Link>, or{' '}
          <Link to="/blog/seller-fulfilled-prime-guide-uk-sellers">Seller Fulfilled Prime</Link>.
        </p>
        <p>
          Fast, accurate fulfilment is now one of the biggest drivers of customer satisfaction. Delayed deliveries and
          pick errors damage trust — which is why our warehouse team targets 99.9% order accuracy and reliable inventory
          control. Brands that outgrow DIY packing often start with{' '}
          <Link to="/blog/how-to-outsource-ecommerce-fulfilment">how to outsource ecommerce fulfilment</Link> and{' '}
          <Link to="/blog/multi-channel-fulfilment-uk">multi-channel fulfilment UK</Link>, then add{' '}
          <Link to="/blog/same-day-dispatch-service">same-day dispatch</Link> and{' '}
          <Link to="/blog/ecommerce-returns-handling-service">returns handling</Link> as volume climbs.
        </p>
        <p>
          Working with Pick Pack Pro means gaining more than warehouse space: a team that communicates clearly, from
          receiving and stock control through pick, pack and ship. Explore{' '}
          <Link to="/our-reviews">customer reviews</Link> for first-hand feedback, or dig into channel-specific plays
          like{' '}
          <Link to="/blog/how-to-fulfil-tiktok-live-orders">how to fulfil TikTok Live orders</Link> and{' '}
          <Link to="/blog/fbm-fulfilment-for-fast-growing-sellers">FBM fulfilment for fast-growing sellers</Link>.
        </p>
        <div className="case-studies-actions">
          <Link to="/our-reviews" className="case-studies-btn case-studies-btn-primary">
            Customer reviews
          </Link>
          <Link to="/multi-channel-fulfillment-services" className="case-studies-btn">
            Multichannel fulfilment
          </Link>
          <Link to="/contact-fulfillment-services" className="case-studies-btn">
            Talk to us
          </Link>
        </div>
      </section>

      <RelatedLinks
        title="Guides behind these success stories"
        serviceLinks={CASE_STUDIES_RELATED_BLOGS}
        blogLink={{ to: '/fulfillment-blog', label: 'All fulfilment blog articles' }}
      />

      <Footer />
    </div>
  );
}
